// redux/scannerSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type ScannerType = 'qr' | 'dl';

interface ScannerState {
  type: ScannerType;
}

const initialState: ScannerState = {
  type: 'qr',
};

const scannerSlice = createSlice({
  name: 'scanner',
  initialState,
  reducers: {
    setScannerType: (state, action: PayloadAction<ScannerType>) => {
      state.type = action.payload;
    },
  },
});

export const { setScannerType } = scannerSlice.actions;
export default scannerSlice.reducer;
